import React from 'react'
import { Icon, Form, Grid } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Title } from '../components'
import { loadAttendances, clearAttendances, getAttendancesCSV } from '../../common/attendances/actions'
import { checkFile, clearDownload } from '../../common/downloads/actions'
import { lists } from '../../common/lib/redux-lists'
import {
  LocationFilter,
  FromToFilter,
  CompanyFilter,
  CourseTypeFilter,
  AttendanceTypeFilter,
} from '../components/filters'

import { AttendancesTable } from '../tables'

const { Row, Column } = Grid

class AttendancesPage extends React.Component {
  constructor(props) {
    super(props)
    this.getCSV = this.getCSV.bind(this)
    this.checkCSV = this.checkCSV.bind(this)
  }
  componentWillReceiveProps(props) {
    const oldLocation = this.props.downloadLocation
    const oldPath = this.props.downloadPath
    const newLocation = props.downloadLocation
    const newPath = props.downloadPath

    if (oldLocation !== newLocation && newLocation !== '') {
      props.checkFile(newLocation)
      this.checkCSVInterval = window.setInterval(this.checkCSV, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkCSVInterval)
    }
  }
  componentWillUnmount() {
    const { waitingForDownload, clearDownload, clearAttendances, list } = this.props
    clearAttendances()
    if (waitingForDownload) clearDownload()
    if (this.checkCSVInterval) window.clearInterval(this.checkCSVInterval)
  }
  getCSV() {
    const { list, getAttendancesCSV } = this.props
    const query = list.$query()
    getAttendancesCSV(query)
  }
  checkCSV() {
    const { checkFile, downloadLocation } = this.props
    checkFile(downloadLocation)
  }
  render() {
    const {
      attendances, meta, viewer, list, waitingForDownload, downloadPath, clearDownload, user
    } = this.props
    return (
      <div>
        <Title message="Prezenční listiny" />
        <aside className="breadcrumbs">
          <span to="/attendances">Prezenční listiny</span>
          <div className="options">
            {((['SUPERVISOR','ADMIN'].indexOf(viewer.role) !== -1) || (viewer.role === 'INSTRUCTOR' && user.canCreateAttendance)) &&
              <Link to="/attendheader/new">
                <button className="with-icon"><Icon name="add" /> Příprava prezenční listiny</button>
              </Link>
            }
          </div>
        </aside>
        <main className="content">
          <Form className="filters" size="big">
            <Grid>
              <Row columns={5}>
                {viewer && viewer.role !== 'FLEET_MANAGER' &&
                  <Column>
                    <strong>Dopravce:</strong>
                    <CompanyFilter multiple {...list.filters['company.in']} />
                  </Column>
                }
                <Column>
                  <strong>Typ:</strong>
                  <CourseTypeFilter multiple {...list.filters['courseType.in']} />
                </Column>
                <Column>
                  <strong>Datum:</strong>
                  <FromToFilter fieldFrom={list.filters['date.from']} fieldTo={list.filters['date.to']} />
                </Column>
                <Column>
                  <strong>Lokace:</strong>
                  <LocationFilter multiple {...list.filters['location.in']} />
                </Column>
                <Column>
                  <strong>Typ:</strong>
                  <AttendanceTypeFilter multiple {...list.filters['state.in']} />
                </Column>
              </Row>
            </Grid>
          </Form>
          <AttendancesTable
            attendances={attendances}
            meta={meta}
            list={list}
            viewer={viewer}
            getCSV={['ADMIN','SUPERVISOR'].indexOf(viewer.role) !== -1 && this.getCSV}
            waitingForDownload={waitingForDownload}
            csv={downloadPath}
            clearDownload={clearDownload}
          />
        </main>
      </div>
    )
  }
}

AttendancesPage.defaultProps = {
  waitingForDownload: false,
  downloadPath: '',
  downloadLocation: '',
}

AttendancesPage.propTypes = {
  attendances: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  loadAttendances: React.PropTypes.func.isRequired,
  clearAttendances: React.PropTypes.func.isRequired,
  list: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  waitingForDownload: React.PropTypes.bool,
  downloadPath: React.PropTypes.string,
  downloadLocation: React.PropTypes.string,
  getAttendancesCSV: React.PropTypes.func.isRequired,
  checkFile: React.PropTypes.func.isRequired,
  clearDownload: React.PropTypes.func.isRequired,
}

AttendancesPage = lists(AttendancesPage, {
  path: 'AttendancesPage',
  filters: ['company.in', 'courseType.in', 'date.from', 'date.to', 'location.in', 'state.in'],
  headings: ['companyNameSort', 'courseType', 'date', 'locationNameSort', 'attendeesCount'],
  debounceTime: 50,
  loadDataAction: (props) => (props.loadAttendances),
  getInitialState: () => ({ sort: '-date', filters: { 'state.in': [/*'PREV','OK'*/] } }),
})

export default connect((state) => (
  {
    attendances: state.attendances.all,
    meta: state.attendances.meta,
    viewer: state.users.viewer,
    waitingForDownload: state.downloads.downloading,
    downloadPath: state.downloads.path,
    downloadLocation: state.downloads.location,
  }),
  { loadAttendances, clearAttendances, getAttendancesCSV, checkFile, clearDownload },
)(AttendancesPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Attendances.js